import { environment } from "src/environments/environment";

export const Config = {
  // get contacts from https://market.nativescript.org/plugins/nativescript-contacts/
  // Also use the prmissions to grant access
   api: environment.api,
  // api: 'http://127.0.0.1:8000/v1/',
  // api: 'http://test-api.shareme.test/v1/',
  stripeAPI: 'https://api.stripe.com/v1/',
  stripeKey: 'pk_test_51Hee3QJBJguilz2QeyAJ53mNgGzkKHeyoNa8PCo5mFgIRNJ99HOjkRGPWwJZFNc6n6BlbAzB8CgqTCR2NCRoDYsN00esFz1O6x',
  stripeAPIKEY: 'sk_test_51Hee3QJBJguilz2QtQUI92zxffUUWv2BYaUVeGi0b05C0HjkaaNKnx8nQVYaZGeh9dpsAC39NGbnEG89Mv2mrmqL00CvXbL1Vg',
  lsLgKey: 'ln',
  lsTokenKey: 'API-Token-Mobile',
  lsConnectivityKey: 'connectivity',
  defaultImageType: 'png',
  defaultRandomStringLength: 24,
  defaultLanguage: 'bg',
  productKey: 'P',
  serviceKey: 'S',
  productType: 'ITEM',
  serviceType: 'SERVICE',
  productLabel: 'Products',
  serviceLabel: 'Servicies',
  pruductImagePrefix: 'product',
  serviceImagePrefix: 'service',
  sizeOfRequests: 270,
  sizeRequestParam: 'pageSize',
  itemsCountPerCategoryOnHomepage: 10,
  instagramUrl: 'https://www.instagram.com/shareme_app',
  facebookUrl: 'https://www.facebook.com/thesharemeapp',
  storeType: 'STORE_ADDRESS',
  bussinessType: 'BUSSINESS_ADDRESS',
  currencyId: 1151,
  pageParam: 'perPage',
  onboarding: 'on_boarding',
  maxPicturesPerProduct: 8,
  initialNumberOfPriceRanges: 5,
  item: 'ITEM',
  service: 'SERVICE',
  storeRole: 'STORE_ADDRESS',
  userRole: 'BIZ_ADDRESS',
  userLocationRole: 'USER_SHIPPING_TYPE_CONTACT',
  userOfficeLocationRole: 'USER_SHIPPING_OFFICE_TYPE_CONTACT',
  invoiceUserLocationRole: 'USER_INVOICE_TYPE_CONTACT',
  invoiceCompanyLocationRole: 'USER_COMPANY_INVOICE_TYPE_CONTACT',
  partnerRole: 'REGULAR_ADDRESS',
  productPerPage: 1,
  defaultImage: '/assets/images/shared/logo.jpg',
  country_uuid:  'fee09419-17d4-4ec0-bf7d-a3b12b5a5cc9',
  user: 'USER',
  defaultCountryId: 100,
  defaultItemsPerPage: 20,
  contactsLSKey: 'contacts',
  bottomTapPageKey: 'btk',
  goToRouteLSKey: 'routeToGo',
  usageTimestamp: 'usageDate',
  shouldShowInitialVoucherKey: 'siv',
  shouldShowInitialVoucherInitKey: 'sivi',
  lastSearchTextKey: 'lslastSearch',
  lastSearchTextKeyGroups: 'lslastSearchGroups',
  lsGroupTabKey: 'groupTab',
  technicalCategoryUUID: 'fb8f7775-8a6a-46ba-b66d-d80a258a1752',
  technicalCategories:  [
    '1f842539-2359-43bb-b0e3-2844958e7a33',
    '48c1c427-cf16-4496-9de8-42c83a547265',
    'eeb32134-e355-4301-ab88-89fb880b01d5',
    'a746dd97-03ae-4cb5-8ee4-52c45e27504c',
    '2276b987-7eed-4ce6-9d50-7b49484cbe62',
    '2f638dec-263c-4b33-a470-5af9e9dfcfd9',
    '8117fb40-8dfc-4980-b59f-37f350a95881',
    '8117fb40-8dfc-4980-b59f-37f350a95881',
    '67690b58-2db0-4f9b-b57d-29d1e01f6ea3'
  ],
  emptyInputPlaceholder: 'Въведи',
  lsCatFromMain: 'lsCFM',
  maxNumberOfFilterOptions: 3,
  invoice: 'INVOICE',
  shipping: 'SHIPPING',
  SPEEDY_CARRIER: '2e8e1789-4ff1-4d8d-8be1-e6e13536bd2f',
  lsLastGroup: 'lslg',
  stripeStatuses: {
    invalidPaymentStatus: 'requires_payment_method',
    confirmationPaymentRequiredStatus: 'requires_action'
  },
  currency: {
    base: 'EUR',
    secondary: 'BGN',
    dualDisplay: false,

    symbols: {
      EUR: '€',
      BGN: 'лв.',
      USD: '$'
    },

    exchangeRates: {
      EUR_BGN: 1.95583,
      BGN_EUR: 1 / 1.95583,

      EUR_USD: 1.08,
      USD_EUR: 0.925
    },

    fractionDigits: 2,
    thousandsSeparator: ' ',
    decimalSeparator: '.',
    dualStyle: 'paren',
    showApproxSign: true
  },
  activeState: 'active'
};
